module.exports = __webpack_public_path__ + "static/media/image_15.2f26ff1f.png";